import { getRouteApi } from '@tanstack/react-router';
import type React from 'react';
import useCollectionPageStyles from 'src/CollectionsPage/CollectionPageStyles';
import CollectionView from 'src/CollectionsPage/CollectionView';
import TopNavBar from 'src/HomePage/TopNavBar/TopNavBar';

const routeApi = getRouteApi('/library/collections/$collectionId');

const CollectionsPage: React.FC = () => {
  const classes = useCollectionPageStyles();
  const { collectionId } = routeApi.useParams();

  return (
    <div className={classes.collectionPage}>
      <TopNavBar simple />
      <div className={classes.collectionContainer}>
        <CollectionView shared={false} collectionId={collectionId} downloadable={false} />
      </div>
    </div>
  );
};

export default CollectionsPage;
